import React, { useState, useEffect, useRef } from 'react';
import MediaExplorerDataPanel from './MediaExplorerDataPanel';
import { toTitleCase } from '../helpers';
import testOptions from '../../data/testPublications.json';

const MediaExplorer = ({ publication, setPublication }) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [mediaType, setMediaType] = useState('');
  const [options, setOptions] = useState([]);
  const isFirstRender = useRef(true);

  const searchPublication = toTitleCase(publication);
  const media_types = [
    'Newspaper',
    'Magazine',
    'Television',
    'Radio',
    'Website'
  ];

  const defaultPublicationLimit = 15;

  const getFilteredOptions = (search = '', selectedPublication = '') => {
    let filteredOptions = testOptions.data;

    let selectedOption = null;
    filteredOptions = filteredOptions.filter((option) => {
      if (
        selectedPublication &&
        option.publication_name.toLowerCase() === selectedPublication.toLowerCase()
      ) {
        selectedOption = option.publication_name;
        return false;
      }
      return true;
    });
  
    if (mediaType) {
      filteredOptions = filteredOptions.filter(
        (option) => option.media_type === mediaType
      );
    }
  
    if (search) {
      filteredOptions = filteredOptions.filter((option) =>
        option.publication_name.toLowerCase().includes(search.toLowerCase())
      );
    }
  
    let newOptions = filteredOptions.map((option) => option.publication_name);
  
    if (selectedOption) {
      newOptions.unshift(selectedOption);
    }
  
    return newOptions.slice(0, defaultPublicationLimit);
  };

  useEffect(() => {
    if (!publication) {
      const mediaScopeElement = document.getElementById('media-scope');
      if (mediaScopeElement) {
        setPublication(mediaScopeElement.getAttribute('data-publication'));
      }
    }
  }, []);

  useEffect(() => {
    setOptions(getFilteredOptions(search, publication));
  }, [search, publication, mediaType]);
  

  const handleSearch = (e) => {
    setSearch(e.target.value);

    if (e.target.value === '') {
      setOptions(getFilteredOptions('', publication));
    } else {
      setOptions(getFilteredOptions(e.target.value, publication));
    }
  };

  const handleClearSearch = () => {
    setSearch('');
    setOptions(getFilteredOptions('', publication));
  };

  const handlePublicationChange = (option) => {
    // make sure ref is set to false if page was loaded without a publication
    if (isFirstRender.current === true) isFirstRender.current = false;

    const newPublication = option.toLowerCase();

    if (newPublication === publication) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mediaScopePublicationChange',
      publication: option,
    });

    setPublication(newPublication);
    const newUrl = `/media-scope/${encodeURIComponent(option)}`;
    window.history.replaceState(null, '', newUrl);
  };

  const handleMediaTypeChange = (e) => {
    const selectedMediaType = e.target.value;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mediaScopeMediaTypeChange',
      mediaType: selectedMediaType,
    });
    
    setMediaType(selectedMediaType);
  }

  const handleClearPublication = () => {
    setPublication('');
    const newUrl = `/media-scope/`;
    window.history.replaceState(null, '', newUrl);
  };

  return (
    <>
      <div className="u--background-color-white u--padding-top-30 u--padding-bottom-30">
        <div className="media-explorer--header u--text-align-center u--padding-top-30 u--padding-bottom-30">
          <h2 className="h3">
            Discover the most popular readership by news source.
          </h2>
          <p>
            Select a news source and get valuable insights into media
            consumption trends.
          </p>
          <div className="media-explorer--search-input-container">
            <div className="media-explorer--search-input">
              <select
                className="media-explorer--media-type"
                value={mediaType}
                onChange={handleMediaTypeChange}
              >
                <option value="">Media Type</option>
                {media_types.map((media_type) => (
                  <option key={media_type} value={media_type}>
                    {media_type}
                  </option>
                ))}
              </select>
              <div className="media-explorer--publication-search-wrapper">
                <input
                  className="media-explorer--publication-search"
                  type="text"
                  placeholder="Search For a News Source"
                  value={search}
                  onChange={handleSearch}
                />
                {!!search && (
                  <button
                    className="media-explorer--clear-search"
                    onClick={handleClearSearch}
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
            <ul className="media-explorer--publications">
              {options.map((option) => (
                <>
                  <li
                    key={option}
                    className={
                      publication?.toLowerCase() === option?.toLowerCase()
                        ? 'media-explorer-publication active'
                        : 'media-explorer-publication'
                    }
                    onClick={
                      publication?.toLowerCase() === option?.toLowerCase()
                        ? handleClearPublication
                        : () => handlePublicationChange(option)
                    }
                  >
                    {option}
                    {publication?.toLowerCase() === option?.toLowerCase() && (
                      <button
                        className="media-explorer--clear-publication"
                        onClick={handleClearPublication}
                      >
                        <i className="fa fa-times"></i>
                      </button>
                    )}
                  </li>
                </>
              ))}
            </ul>
          </div>
        </div>
        <div className="grid u--margin-top-30">
          <div className="grid__col-xs-12">
            <MediaExplorerDataPanel
              publication={publication}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaExplorer;
